import { Box, Container, Grid, GridItem, Heading, Link, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const CartaDerechosConsumidor = () => {
    return (
        <Container maxWidth={{ base: "7xl", md: "8xl" }} pt={{ base: 14, md: 24 }} mx="auto">
            <Header />
            <Head>
                <title>Carta de Derechos del Consumidor</title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiabroker"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3} borderLeftColor="#17669D" borderLeftWidth="3px">
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }} mx="auto">
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "4xl", base: "2xl" }}
                            textAlign="left"
                            mb="8"
                            color="accent.500"
                            fontWeight="bold"
                            ml={4}
                        >
                            Carta de Derechos del Consumidor
                        </Heading>
                    </Box>
                    <Box lineHeight="1.8" mb="8">
                        <Text mb={8} ml={6}>
                            1. Recibir, respecto de los bienes inmuebles ofertados, información y
                            publicidad veraz, clara y actualizada, sin importar el medio por el que
                            se comunique, incluyendo los medios digitales, de forma tal que le
                            permita al consumidor tomar la mejor decisión de compra conociendo de
                            manera veraz las características del inmueble que está adquiriendo,
                            conforme a lo dispuesto por la Ley.
                        </Text>
                        <Text mb={8} ml={6}>
                            2. Conocer la información sobre las características del inmueble, entre
                            éstas: la extensión del terreno, superficie construida, tipo de
                            estructura, instalaciones, acabados, accesorios, lugar de
                            estacionamiento, áreas de uso común, servicios con que cuenta y estado
                            general físico del inmueble.
                        </Text>
                        <Text mb={8} ml={6}>
                            3. Elegir libremente el inmueble que mejor satisfaga sus necesidades y
                            se ajuste a su capacidad de compra.
                        </Text>
                        <Text mb={8} ml={6}>
                            4. No realizar pago alguno hasta que conste por escrito la relación
                            contractual, exceptuando los referentes a anticipos y gastos operativos,
                            en los términos previstos por la LFPC.
                        </Text>
                        <Text mb={8} ml={6}>
                            5. Firmar un contrato de adhesión bajo el modelo inscrito en la
                            Procuraduría Federal del Consumidor, en el que consten los términos y
                            condiciones de la compraventa del bien inmueble. Posterior a su firma,
                            el proveedor tiene la obligación de entregar una copia del contrato
                            firmado al consumidor.
                        </Text>
                        <Text mb={8} ml={6}>
                            6. Adquirir un inmueble que cuente con las características de seguridad
                            y calidad que estén contenidas en la normatividad aplicable y plasmadas
                            en la información y publicidad que haya recibido.
                        </Text>
                        <Text mb={8} ml={6}>
                            7. Recibir el bien inmueble en el plazo y condiciones acordados con el
                            proveedor en el contrato de adhesión respectivo.
                        </Text>
                        <Text mb={8} ml={6}>
                            8. En su caso, ejercer las garantías sobre bienes inmuebles previstas en
                            la LFPC, considerando las especificaciones previstas en el contrato de
                            adhesión respectivo.
                        </Text>
                        <Text mb={8} ml={6}>
                            9. Recibir la bonificación o compensación correspondiente en términos de
                            la LFPC, en caso de que una vez ejercida la garantía, persistan defectos
                            o fallas en el inmueble. Asimismo, a que se realicen las reparaciones
                            necesarias en caso de defectos o fallas imputables al proveedor, u optar
                            por la substitución del inmueble o rescisión del contrato cuando
                            proceda.
                        </Text>
                        <Text mb={8} ml={6}>
                            10. Contar con canales y mecanismos de atención gratuitos y accesibles
                            para consultas, solicitudes, reclamaciones y sugerencias al proveedor, y
                            conocer el domicilio señalado por el proveedor para oír y recibir
                            notificaciones.
                        </Text>
                        <Text mb={8} ml={6}>
                            11. Derecho a la protección por parte de las autoridades competentes y
                            conforme a las leyes aplicables, incluyendo el derecho a presentar
                            denuncias y reclamaciones ante las mismas.
                        </Text>
                        <Text mb={8} ml={6}>
                            12. Tener a su disposición un Aviso de Privacidad para conocer el
                            tratamiento que se dará a los datos personales que proporcione y
                            consentirlo, en su caso; que sus datos personales sean tratados conforme
                            a la normatividad aplicable y, conocer los mecanismos disponibles para
                            realizar el ejercicio de sus Derechos de Acceso, Rectificación,
                            Cancelación y Oposición.
                        </Text>
                        <Text mb={8} ml={6}>
                            13. Recibir un trato libre de discriminación, sin que se le pueda negar
                            o condicionar la atención o venta de una vivienda por razones de género,
                            nacionalidad, étnicas, preferencia sexual, religiosas o cualquiera otra
                            particularidad en los términos de la legislación aplicable.
                        </Text>
                        <Text mb={8} ml={6}>
                            14. Elegir libremente al notario público para realizar el trámite de
                            escrituración.{" "}
                        </Text>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
};

export default CartaDerechosConsumidor;
